var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('div',{staticClass:"ods-nav-collapse__bar",class:{
    'has-scroll': _vm.hasScroll,
    'collapsed': _vm.collapsed
  },on:{"click":_vm.collapseClick}},[_c('ods-icon',{staticClass:"ods-nav-collapse__icon",attrs:{"name":_vm.collapsed ? 'double-right' : 'double-left'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }